import React, {Component} from "react";
import InfografikComponentOpenData from "../../../components/open_data/infografik/InfografikComponentOpenData";

export class InfografikOpenData extends Component{
    render(){
        return(
            <InfografikComponentOpenData />
        )
    }
}

export default InfografikOpenData;